<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g>
    <g>
      <path class="filled" d="M25.021,6.979a12.758,12.758,0,1,0,0,18.042A12.758,12.758,0,0,0,25.021,6.979ZM21.688,19.143l-2.545,2.545L16,18.545l-3.142,3.143-2.546-2.545L13.455,16l-3.143-3.142,2.546-2.546L16,13.455l3.143-3.143,2.545,2.546L18.546,16Z" fill="currentColor"/>
      <polygon class="cutout" points="19.143 10.312 16 13.455 12.858 10.312 10.312 12.858 13.455 16 10.312 19.143 12.858 21.688 16 18.545 19.143 21.688 21.688 19.143 18.546 16 21.688 12.858 19.143 10.312" fill="#fff"/>
    </g>
    <rect width="32" height="32" fill="none"/>
  </g>
</svg>
